import { useState } from 'react';
import styles from './AddNewForm.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';
import HeadingAndDropDown from '../../components/HeadingAndDropDown/HeadingAndDropDown';

const AddNewForm = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    formType: '', // form dropdown value
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = () => {
    if (!formData.formType) {
      alert('Please select a form.');
      return;
    }
    console.log('Form submitted:', formData);
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setFormData({ formType: '' });
    dispatch(closeModal());
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon heading="Add New Form" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.body}>
        <div className={styles.dateRow}>
          <HeadingAndDropDown
            label="New Form"
            name="formType"
            value={formData.formType}
            onChange={handleChange}
            placeholder="Select New Form"
            options={[
              { label: 'Form 1', value: 'form1' },
              { label: 'Form 2', value: 'form2' },
              { label: 'Form 3', value: 'form3' },
            ]}
            required
          />
        </div>

        <SaveAndCancel
          cancelLabel="Cancel"
          saveLabel="Update"
          onCancel={handleCancel}
          onSave={handleUpdate}
        />
      </div>
    </div>
  );
};

export default AddNewForm;
